export default __webpack_public_path__ + "static/media/newImg1.6a98f9bc.svg";